export class StudentInternShipKeyDetails{
    showLabel:string;
    showValue: string;
    questionType?:number;
}